import { createSlice } from "@reduxjs/toolkit";

export const styleSlice = createSlice({
    name: 'style',
    initialState: {
        payload: {
            marginLeft: '250px',
            width : '81%'
        }
    },

    reducers: {
        style: (state, action) => {
            state.payload = action.payload;
        }
    }
})

export const {style} = styleSlice.actions;
export default styleSlice.reducer 